/**
 * Javascript pro veřejnou část stránek.
 *
 * @package    www-elisha/rubelo.cz
 * @subpackage .
 * @author     Reklalink <info@reklalink.cz>
 * @copyright  2023 Reklalink s.r.o.
 */

$(document).ready(
	function () {
		rubelo_top_menu();
		rubelo_homepage_slider();

		rubelo_category_sidebar();
		rubelo_category_modal();

		rubelo_grid_border();

		rubelo_page_carousel();
		rubelo_detail_carousel();
		rubelo_product_carousel();
		rubelo_download_carousel();

		rubelo_configurator_message();

		rubelo_bs_breakpoint();
		$(window).resize(
			function () {
				rubelo_bs_breakpoint()
			}
		);

		if ($('.autoComplete').length) {
			init_autocomplete('autoCompleteH');
		}//end if

		rubelo_newsletter_hcaptcha();
		my_validate();
	}
);


function rubelo_top_menu()
{
	$('#nav-top .nav-item > .nav-link').on(
		'click',
		function () {
			var self = $(this);
			var bp   = $('body').attr('data-breakpoint');

			if (bp === 'lg' || bp === 'xl' || bp === 'xxl' || bp === 'xxxl') {
				window.location.href = self.attr('href');
			}
		}
	);
}

function rubelo_homepage_slider()
{
	if ($('#homepage-carousel').length) {
		const swiper = new Swiper(
			'#homepage-carousel',
			{
				loop: true,
				slidesPerView: 1,
				preventClicksPropagation: false,
				grabCursor: true,
				shortSwipes: false,
				longSwipesMs: 50,
				longSwipesRatio: 0.1,
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev"
				},
				pagination: {
					el: ".swiper-pagination",
					clickable: true
				}
			}
		);
	}//end if
}

function rubelo_category_sidebar()
{
	$('.category-collapse-toggle').on(
		'click',
		function () {
			var el = $(this);
			if (el.hasClass('collapsed')) {
				el.html('-');
			} else {
				el.html('+');
			}
		}
	);

	if ($('.collapse-text').length) {
		$('.collapse-text').on(
			'show.bs.collapse',
			function () {
				var control = $('#' + $(this).attr('id') + '-control');

				if (control.length
					&& typeof control.attr('data-text-show') !== undefined
					&& typeof control.attr('data-text-hide') !== undefined
				) {
					$(control).text(control.attr('data-text-hide'));
				}
			}
		);

		$('.collapse-text').on(
			'hide.bs.collapse',
			function () {
				var control = $('#' + $(this).attr('id') + '-control');

				if (control.length
					&& typeof control.attr('data-text-show') !== undefined
					&& typeof control.attr('data-text-hide') !== undefined
				) {
					$(control).text(control.attr('data-text-show'));
				}
			}
		);
	}//end if
}


function rubelo_category_modal()
{
	$('#filter-modal a[data-toggle="list"]').on(
		'shown.bs.tab click',
		function () {
			$('#filter-modal .filters-data').addClass('active');
		}
	);

	$('#filter-modal .filter-back').on(
		'click touch',
		function () {
			$('#filter-modal .filters-data').removeClass('active');
		}
	);
}

function project_basket_render_success(json)
{
	var carousel_product = $('#carousel_product');
	if (carousel_product.length
		&& typeof json === 'object'
		&& typeof json.data.selected.item_variant_code !== 'undefined'
	) {
		var item_variant_code = json.data.selected.item_variant_code;
		var slide             = carousel_product.find("[data-filename='" + item_variant_code + "']");
		if (slide.length && slide.attr('data-i').length && typeof slide.attr('data-i') === 'string') {
			var i = parseInt(slide.attr('data-i'));
			carousel_product.carousel(i);
		}
	}
}

function project_category_ajax_call_hook(el)
{
	var id_label  = el.attr('data-id-label');
	var id_option = el.attr('data-id-option');

	var type;
	if (typeof id_label !== 'undefined') {
		type = 'label';
	}

	if (typeof id_option !== 'undefined') {
		type = 'option';
	}

	var checked    = $('[data-id-' + type + '="' + id_option + '"]:checked');
	var control    = $('#btn-' + type + '-filter-' + id_option);
	var class_name = 'contains-selected';

	if (checked.length) {
		if (control.hasClass(class_name) === false) {
			control.addClass(class_name);
		}
	} else {
		control.removeClass(class_name);
	}
}

function rubelo_grid_border()
{
	if ($('#catalog-content .item-grid').length) {
		rubelo_grid_change();
		window.addEventListener("resize", rubelo_grid_change);
	}
}

function rubelo_grid_change()
{
	var item_grid  = document.querySelector('#catalog-content .item-grid');
	var self       = $(item_grid);
	var last_count = self.attr('data-last-count');

	var gridComputedStyle = window.getComputedStyle(item_grid);
	var new_count         = gridComputedStyle.getPropertyValue('grid-template-columns').split(' ').length;

	if (last_count !== new_count) {
		self.attr('data-last-count', new_count);

		for (var i = 0; i < 10; i++) {
			self.removeClass('item-grid-columns-' + i);
		}

		self.addClass('item-grid-columns-' + new_count);
	}
}

function project_category_render_hook()
{
	rubelo_grid_change();
}

function rubelo_page_carousel()
{
	if ($('#page-gallery').length) {
		const swiper = new Swiper(
			'#page-gallery',
			{
				loop: false,
				slidesPerView: 1.2,
				spaceBetween: 16,
				watchOverflow: true,
				freeMode: true,
				grabCursor: true,
				breakpoints: {
					750: {
						slidesPerView: 2.2
					},
					1000: {
						slidesPerView: 3.2
					},
					1250: {
						slidesPerView: 4.2
					},
					1500: {
						slidesPerView: 5.2
					}
				}
			}
		);
	}//end if
}

function rubelo_detail_carousel()
{
	if ($('#carousel_product').length) {
		$('#carousel_product').parent().find('.product-carousel-thumbs').scrollLeft(0);

		$('#carousel_product').on(
			'slide.bs.carousel',
			function (event) {
				var carousel   = $(this);
				var thumbs_row = carousel.parent().find('.product-carousel-thumbs');
				var item_to    = thumbs_row.find('.list-group-item.s' + event.to);

				$('.product-carousel-thumbs .list-group-item').removeClass('active');
				item_to.addClass('active');

				var scroll_to = 0;
				for (var i = 1; i <= event.to; i++) {
					var item = thumbs_row.find('.list-group-item.s' + i)
					if (item.length) {
						scroll_to += item.width();
					}
				}

				if (scroll_to > 0) {
					scroll_to = (scroll_to - 2);
				}

				$('.product-carousel-thumbs').animate({scrollLeft: scroll_to}, 300);
			}
		).on(
			'slid.bs.carousel',
			function (event) {
				var target_3d_viewer = $(event.relatedTarget).find('.online_3d_viewer');
				if (target_3d_viewer.length) {
					var canvas = target_3d_viewer.find('canvas');

					if (canvas.length === 0) {
						way = '/js/3d';
						OV.SetExternalLibLocation('/js/3d');
						OV.Init3DViewerElements();
					}
				}
			}
		);
	}//end if
}

function rubelo_product_carousel()
{
	if ($('.product-carousel').length) {
		$('.product-carousel').each(
			function (index, element) {
				$(this).addClass('spc' + index);
				$(this).find('.product-carousel-pagination').addClass('spc-sp' + index);
				$(this).find('.product-carousel-navigation-prev').addClass('spc-sn-p' + index);
				$(this).find('.product-carousel-navigation-next').addClass('spc-sn-n' + index);


				var bp = {
					768: {
						slidesPerView: 2.2
					},
					992: {
						slidesPerView: 3.2
					},
					1200: {
						slidesPerView: 4.2
					},
					1500: {
						slidesPerView: 5.2
					}
				};

				if ($(this).parents('#catalog-item').length) {
					bp = {
						768: {
							slidesPerView: 2.2
						},
						992: {
							slidesPerView: 3.2
						},
						1200: {
							slidesPerView: 3.2
						},
						1500: {
							slidesPerView: 4.2
						}
					};
				}

				const swiper = new Swiper(
					'.spc' + index,
					{
						loop: false,
						slidesPerView: 1.05,
						spaceBetween: 0,
						watchOverflow: true,
						freeMode: true,
						watchSlidesProgress: true,
						grabCursor: true,
						breakpoints: bp,
						navigation: {
							nextEl: '.spc-sn-n' + index,
							prevEl: '.spc-sn-p' + index
						},
						pagination: {
							el: '.spc-sp' + index,
							clickable: true
						}
					}
				);
			}
		);
	}//end if
}

function rubelo_download_carousel()
{
	if ($('.download-carousel').length) {
		$('.download-carousel').each(
			function (index, element) {
				$(this).addClass('s' + index);
				$(this).find('.swiper-button-prev').addClass('bp' + index);
				$(this).find('.swiper-button-next').addClass('bn' + index);

				const swiper = new Swiper(
					'.s' + index,
					{
						loop: false,
						slidesPerView: 1.2,
						spaceBetween: 16,
						watchOverflow: true,
						freeMode: true,
						grabCursor: true,
						breakpoints: {
							750: {
								slidesPerView: 2.2
							},
							1500: {
								slidesPerView: 3.2
							}
						},
						navigation: {
							nextEl: '.bn' + index,
							prevEl: '.bp' + index
						}
					}
				);
			}
		);
	}//end if
}


function rubelo_configurator_message()
{

	window.addEventListener(
		"message",
		function (event) {
			if (event.origin === 'https://partner-configurator.q-railing.com') {
				var value = 0;
				if (event.data.value.length > 0) {
					value = event.data.value;
				}

				var currency = 'CZK';
				if (event.data.currency.length > 0) {
					currency = event.data.currency;
				}

				var email = '';
				if (event.data.email.length > 0) {
					email = event.data.email;
				}

				window.dataLayer = window.dataLayer || [];
				dataLayer.push(
					{
						event: 'configurator_submitted',
						configurator_submitted: {
							value: value,
							currency: currency,
							email: email
						}
					}
				);
			}//end if
		}
	);
}

function rubelo_bs_breakpoint()
{
	var width = $(window).width();
	var bp;

	if (width < 576) {
		bp = 'xs';
	} else if (width < 768) {
		bp = 'sm';
	} else if (width < 992) {
		bp = 'md';
	} else if (width < 1200) {
		bp = 'lg';
	} else if (width < 1470) {
		bp = 'xl';
	} else if (width < 1740) {
		bp = 'xxl';
	} else {
		bp = 'xxxl';
	}

	$('body').attr('data-breakpoint', bp);
}

function init_autocomplete(element_id)
{
	var element           = '#' + element_id;
	var element_result_id = element_id + '_result_wrapper';
	var element_result    = '#' + element_result_id;

	new autoComplete(
		{
			data: {
				src: async function () {
					const placeholder = document.querySelector(element).dataset.placeholder;
					const query       = document.querySelector(element).value;

					const source = await fetch('/content/search/?ajax=autocomplete&q=' + query);
					const data   = await source.json();

					document.querySelector(element).setAttribute('placeholder', placeholder);

					return data;
				},
				key: [
					'name'
				],
				cache: false
			},
			sort: function (a, b) {
				if (a.value.score < b.value.score) {
					return 1;
				}

				if (a.value.score > b.value.score) {
					return -1;
				}


				if (a.match < b.match) {
					return -1;
				}

				if (a.match > b.match) {
					return 1;
				}

				return 0;
			},
			selector: element,
			threshold: 1,
			debounce: 400,
			searchEngine: function (query, record, config) {
				return record;
			},
			highlight: false,
			maxResults: 10,
			resultsList: {
				render: true,
				container: function (source) {
					source.setAttribute('id', element_result_id);
					source.setAttribute('class', 'autoComplete_result_wrapper d-none');
				},
				destination: document.querySelector(element),
				position: 'afterend',
				element: 'div'
			},
			resultItem: {
				content: function (data, source) {
					source.innerHTML = '<a href="' + data.value.link + '"><span class="item_image"><img src="' + data.value.image + '" alt="' + data.match + '"></span><span class="item_name">' + data.match + '</span><span class="item_price">' + data.value.price + '</span></a>';
				},
				element: 'span'
			}
		}
	);

	// Když se spustí autoComplete event (začneme vyhledávat).
	document.querySelector(element).addEventListener(
		'autoComplete',
		function (event) {
			// Pokud máme k dispozici nějaké výsledky z vyhledávání.
			if (event.detail.matches > 0) {
				// Odstraníme zneviditelnění boxu s výsledky.
				document.querySelector(element_result).classList.remove('d-none');
				// Zaregistrujeme si spuštění funkce autocomplete_click kdekoli v okně prohlížeče.
				document.addEventListener('click', autocomplete_click);
			} else {
				// Pokud nejsou žádný výsledky nic nezobrazíme.
				document.querySelector(element_result).classList.add('d-none');
				// Případný handler kliku dáme pryč aby se nehromadily.
				document.removeEventListener('click', autocomplete_click);
			}
		}
	);

	// Když uživatel klikne do vyhledávacího políčka.
	document.querySelector(element).addEventListener(
		'click',
		function (event) {
			// ID vyhledávacího políčka.
			var id = event.target.id;
			// Počet prvků v divu s výsledky = počet výsledků.
			var len = document.querySelector('#' + id + '_result_wrapper').children.length;

			// Pokud jsou k dispozici nějaké výsledky.
			if (len > 0) {
				// Zobrazíme výsledkové pole.
				document.querySelector('#' + id + '_result_wrapper').classList.remove('d-none');

				// Smažeme handler kliku kdekoliv a zaregistrujeme nový aby se výsledky daly opět zavřít klikem bokem.
				document.removeEventListener('click', autocomplete_click);
				document.addEventListener('click', autocomplete_click);
			} else {
				// Pokud nejsou výsledky zajistíme aby nebyly zobrazeny.
				document.querySelector('#' + id + '_result_wrapper').classList.add('d-none');
				// Odstraníme handler pro zavírání výsledků.
				document.removeEventListener('click', autocomplete_click);
			}
		}
	);

}

function autocomplete_click(event)
{
	// Pokud klikneme někam kromě vyhledávacího pole nebo pole s výsledky.
	if (event.target.classList.contains('autoComplete_result_wrapper') === false
		&& event.target.classList.contains('autoComplete') === false
	) {
		// Pole s výsledky zavřeme.
		document.querySelector('.autoComplete_result_wrapper').classList.add('d-none');
		// Odstraníme handler pro zavírání výsledků.
		document.removeEventListener('click', autocomplete_click)
	}
}

function rubelo_newsletter_hcaptcha()
{
	if ($('.as-2-submit').length) {
		$('.as-2-submit').on(
			'submit change',
			function () {
				$('.as-h-captcha').removeClass('d-none');
			}
		);
	}
}

function my_validate()
{
	var ajax_form_before_lang_arr = {
		cs: 'Formulář se odesílá, prosím počkejte.',
		en: 'The form is being submitted, please wait.',
		ru: 'Форма отправляется, пожалуйста, подождите.',
		de: 'Das Formular wird gesendet, bitte warten.'
	};

	var ajax_form_error_lang_arr = {
		cs: 'Bohužel formulář nelze odeslat, prosím kontaktujte nás jinou cestou. Děkujeme za pochopení.',
		en: 'Unfortunately the form cannot be sent, please contact us in another way Thank you for your understanding.',
		ru: 'К сожалению, форма не может быть отправлена, пожалуйста, свяжитесь с нами другим способом.\
				Спасибо за ваше понимание.',
		de: 'Leider kann das Formular nicht gesendet werden. Bitte kontaktieren Sie uns auf andere Weise.\
				Vielen Dank für Ihr Verständnis.'
	};

	var form = $('.validate');
	form.each(
		function () {
			var self = $(this);
			$(this).validate(
				{
					ignore: [],
					lang: $('html').attr('lang'),
					highlight: function (element) {
						$(element).closest('div').addClass('has-error');
					},
					unhighlight: function (element) {
						if ($(element).hasClass('error-as-tooltip')) {
							$(element).tooltip('dispose')
						} else {
							$(element).closest('div').removeClass('has-error');
						}
					},
					errorElement: 'span',
					errorClass: 'form-text',
					errorPlacement: function (error, element) {
						if (element.hasClass('error-as-tooltip')) {
							var last_error = $(element).attr('data-title');
							if (last_error !== error.text()) {
								$(element).tooltip('dispose')
									.attr('data-title', error.text())
									.data('title', error.text())
									.tooltip(
										{
											trigger: 'manual',
											template: '<div class="tooltip has-error" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'
										}
									)
									.tooltip('show');
							}
						} else if (element.parent('.input-group').length) {
							$('<div>', {class: 'has-error'}).append(error).insertAfter(element.parent());
						} else if (element.hasClass('select2') || element.hasClass('is-select2')) {
							error.insertAfter(element.parent().find('.select2-container'));
						} else if (element.parent('.custom-checkbox').length) {
							error.insertAfter(element.parent('.custom-checkbox').find('.custom-control-label'));
						} else if (element.parent('.custom-file').length) {
							error.insertAfter(element.parent('.custom-file').find('.custom-file-label'));
						} else {
							error.insertAfter(element);
						}//end if
					},
					submitHandler: function (form) {
						var init = g_recaptcha_v3_init(self);
						if (init === false) {
							// Pokud není g-recaptcha připravena nepokračujeme.
							return false;
						}

						var ajax = $(form).attr('data-ajax');

						if (typeof ajax !== typeof undefined && ajax !== false) {
							var form_response = $(form).find('.response');
							var form_data     = new FormData();

							// Projdem všechna data formuláře.
							var self_zero_length = self[0].length;
							for (i = 0; i < self_zero_length; i++) {
								var item  = self[0][i];
								var $item = $(item);
								if ($item.attr('type') === 'hidden' || $item.attr('type') === 'button' || $item.attr('type') === 'submit') {
									continue
								} else if ($item.attr('type') === 'file') {
									// Vložíme obrázky.
									var files_length = item.files.length;
									for (j = 0; j < files_length; j++) {
										form_data.append($item.attr('name'), item.files[j]);
									}
								} else if ($item.attr('type') === 'checkbox') {
									// Emulace chování PHP.
									if ($item.is(':checked') === true) {
										form_data.append($item.attr('name'), 'on');
									}
								} else {
									form_data.append($item.attr('name'), $item.val());
								}
							}//end for

							$.ajax(
								{
									url: '?ajax=' + ajax,
									type: 'POST',
									data: form_data,
									processData: false,
									contentType: false,
									beforeSend: function () {
										$(form).find('button[type="submit"]').attr('disabled','disabled');
										form_response.empty();
										form_response.append('<div class="alert alert-info" role="alert"><i class="fa fa-refresh fa-spin fa-3x fa-fw"></i> ' + ajax_form_before_lang_arr[$('html').attr('lang')] + '</div>');
									},
									success: function (response) {
										form_response.empty();
										form_response.append(response);

										if (typeof my_validate_send_event === 'function') {
											my_validate_send_event(
												self.attr('data-matomo-event-submit'),
												self.attr('data-gtm-event-submit')
											);
										}
									},
									error: function () {
										form_response.empty();
										form_response.append('<div class="alert alert-danger" role="alert"><i class="fa fa-ban fa-3x fa-fw"></i> ' + ajax_form_error_lang_arr[$('html').attr('lang')] + '</div>');
									}
								}
							);
							return false;
						} else {
							if (typeof my_validate_send_event === 'function') {
								my_validate_send_event(
									self.attr('data-matomo-event-submit'),
									self.attr('data-gtm-event-submit')
								);
							}

							return true;
						}//end if
					}
				}
			);
		}
	);
}

function project_selected_filter_template(id, value, label)
{
	return '<span class="selected-filter badge badge-primary mouse-pointer mr-2" id="selected-' + id + '">' + value + ' &times;</span>';
}
